import * as wam from '@tcc/wam';

import type { Tracker } from '../types/tracker';

export const getErrorMessage = (error) => { // shameless plug from fixit-tool
  let message = '';
  if (Array.isArray(error)) {
    message = error.map((item) => getErrorMessage(item)).join('. ');
  } else if (error?.graphQLErrors?.length) {
    message = error?.graphQLErrors?.map(item => item.message).join(', ');
  } else if (error?.networkError) {
    message = error?.networkError?.result?.errors?.map(item => item.message).join(', ');
  } else if (error instanceof Error || error?.message) {
    message = error.message;
  } else {
    message = String(error);
  }

  return message;
};

export const errorTracker = (
  { trackError }: Tracker, error: { name: string, message: string }, details: Record<string, unknown>
): Promise<unknown> => {
  const context = {...details, loggedUserId: wam.getUserId() };
  
  return trackError(error, context);
};

export const eventTracker = (
  { trackEvent }: Tracker, eventName: string, details: Record<string, unknown>
): Promise<unknown> => {
  const context = {...details, loggedUserId: wam.getUserId() };
  
  return trackEvent(eventName, context);
};

export { datadogTracker } from './datadog-tracker';
export { heapTracker } from './heap-tracker';
export { mockTracker } from './mock-tracker';
